import { DocSearch } from "@docsearch/react";

export default function Search() {
  return (
    <DocSearch
      appId="CG0H135ILY"
      indexName="appsignalnew"
      apiKey="18b8bba4d0cd999349014d875d048a6c"
    />
  );
}
